import type { OilPhaseVolumeFactorBoCalculator } from "../../d";

export const oilPhaseVolumeFactorBoCalculator: OilPhaseVolumeFactorBoCalculator =
  params => {
    throw new Error("Bo calculation is not implemented for Lasater method");
  };
